import { differenceInCalendarDays, max, type DateArg, type MaxOptions } from 'date-fns'
import { t } from 'i18next'

import { StringUtils } from '@/utils/string.utils'

export function formatDateToPtBr(dateString: string, options?: Intl.DateTimeFormatOptions): string {
  const date = new Date(dateString)
  const defaultOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }

  const formatter = new Intl.DateTimeFormat('pt-BR', {
    ...defaultOptions,
    ...options,
  })
  return formatter.format(date)
}

export function daysSince(dateString: string): number {
  const date = new Date(dateString)
  const today = new Date()

  return Math.abs(differenceInCalendarDays(today, date))
}

export function formatDaysSince(daysAgo: number): string {
  if (daysAgo === 0) return t('common:hoje')
  return StringUtils.singularPlural(daysAgo, t('common:ha_dia'), t('common:ha_dias', { dias: daysAgo }))
}

export const dateTimeFormat = (value: string): string => {
  return new Intl.DateTimeFormat(navigator.language).format(new Date(value))
}

export const maxDate = (dates: Array<DateArg<Date>>, options?: MaxOptions<Date> | undefined): Date => {
  return max(dates, options)
}

export const dateToUTC = (dateString: string): string => {
  const now = new Date()
  const date = new Date(dateString + 'T00:00:00')
  date.setHours(now.getHours(), now.getMinutes(), now.getSeconds())
  return date.toJSON()
}

export const extractDateOnly = (isoString: string | null | undefined): string | null => {
  if (!isoString) return null
  return isoString.split('T')[0] ?? null
}
